import React from 'react';
import FooterComponent from "../../components/Footer/footer.component";

const PolicyPage = () => {
    return (
        <div className="container policy">
            <style>
                {`
                .policy p {
                line-height: 1.5 !important;
                }
                `}
            </style>
            <p><strong>1. Общие положения</strong></p>
            <p>Настоящая Политика обработки персональных данных разработана в соответствии с требованиями Федерального
                закона от 27.07.2006 № 152-ФЗ &laquo;О персональных данных&raquo; и регулирует порядок обработки
                персональных данных, а также меры по обеспечению их безопасности, применяемые ООО
                УЦ &laquo;АвтоМетод&raquo; (далее &mdash;&nbsp;<strong>Оператор</strong>).</p>
            <p>1.1. Главным приоритетом Оператора является соблюдение прав и свобод граждан при обработке их
                персональных данных, включая защиту права на неприкосновенность частной жизни, личную и семейную
                тайну.</p>
            <p>1.2. Настоящая Политика распространяется на всю информацию, которую Оператор может получить о посетителях
                сайта&nbsp;avtometod.ru.</p>
            <p><strong>2. Основные термины</strong></p>
            <p>2.1.&nbsp;<strong>Автоматизированная обработка персональных данных</strong>&nbsp;&mdash; обработка данных
                с использованием компьютерных технологий.<br/>2.2.&nbsp;<strong>Блокирование персональных
                    данных</strong>&nbsp;&mdash; временное прекращение обработки (кроме случаев уточнения
                данных).<br/>2.3.&nbsp;<strong>Веб-сайт&nbsp;</strong>&mdash; совокупность графических, информационных
                материалов и программного обеспечения, доступного в сети Интернет по
                адресу&nbsp;avtometod.ru.<br/>2.4.&nbsp;<strong>Информационная система персональных
                    данных</strong>&nbsp;&mdash; базы данных и технические средства, обеспечивающие их
                обработку.<br/>2.5.&nbsp;<strong>Обезличивание персональных данных</strong>&nbsp;&mdash; действия,
                делающие невозможным идентификацию субъекта без дополнительной информации.<br/>2.6.&nbsp;<strong>Обработка
                    персональных данных</strong>&nbsp;&mdash; любые действия с данными, включая сбор, хранение,
                использование, передачу и уничтожение.<br/>2.7.&nbsp;<strong>Оператор</strong>&nbsp;&mdash; организация,
                определяющая цели и порядок обработки персональных данных.<br/>2.8.&nbsp;<strong>Персональные
                    данные</strong>&nbsp;&mdash; любая информация, относящаяся к Пользователю
                сайта&nbsp;avtometod.ru.<br/>2.9.&nbsp;<strong>Пользователь</strong>&nbsp;&mdash; посетитель
                веб-сайта&nbsp;avtometod.ru.<br/>2.10.&nbsp;<strong>Предоставление персональных
                    данных&nbsp;</strong>&mdash; передача данных конкретному лицу или кругу лиц.<br/>2.11.&nbsp;<strong>Распространение
                    персональных данных</strong>&nbsp;&mdash; действия, направленные на раскрытие данных неограниченному
                кругу лиц.<br/>2.12.&nbsp;<strong>Трансграничная передача данных</strong>&nbsp;&mdash; передача
                персональных данных в иностранное государство.<br/>2.13.&nbsp;<strong>Уничтожение персональных
                    данных</strong>&nbsp;&mdash; действия, приводящие к безвозвратному удалению данных.</p>
            <p><strong>3. Категории обрабатываемых данных</strong></p>
            <p>3.1. ФИО Пользователя.<br/>3.2. Контактные телефоны.<br/>3.3. Обезличенные данные (включая файлы&nbsp;
                <strong>cookie</strong>), собираемые с помощью сервисов аналитики (Яндекс.Метрика и др.).<br/>3.4. Все
                перечисленные данные далее именуются&nbsp;<strong>Персональные данные.</strong></p>
            <p><strong>4. Цели обработки данных</strong></p>
            <p>4.1. Обработка данных осуществляется для:</p>
            <ul className="lst-kix_p8b1d8xiw1m1-0 start">
                <li>Информирования Пользователя через электронную почту.</li>
                <li>Предоставления доступа к сервисам и материалам сайта.<br/>4.2. Оператор вправе направлять
                    уведомления о новых продуктах, акциях и событиях. Пользователь может отказаться от рассылки,
                    отправив запрос на&nbsp;info@avtometod.ru&nbsp;с пометкой&nbsp;<strong>&laquo;Отказ от
                        уведомлений&raquo;</strong>.<br/>4.3. Обезличенные данные используются для анализа поведения
                    пользователей и улучшения работы сайта.
                </li>
            </ul>
            <p><strong>5. Правовые основания обработки</strong></p>
            <p>5.1. Оператор обрабатывает данные только при их добровольном предоставлении Пользователем через формы на
                сайте&nbsp;<strong>avtometod.ru</strong>. Отправляя данные, Пользователь соглашается с настоящей
                Политикой.<br/>5.2. Обезличенные данные обрабатываются при разрешении в настройках браузера
                (включены&nbsp;<strong>cookie</strong>&nbsp;и&nbsp;<strong>JavaScript</strong>).</p>
            <p><strong>6. Порядок обработки и защиты данных</strong></p>
            <p>Оператор обеспечивает безопасность данных, применяя необходимые правовые, организационные и технические
                меры.<br/>6.1. Доступ к персональным данным ограничен и предоставляется только уполномоченным
                лицам.<br/>6.2. Данные не передаются третьим лицам, за исключением случаев, предусмотренных
                законом.<br/>6.3. Пользователь может уточнить или изменить свои данные, отправив запрос
                на&nbsp;info@avtometod.ru&nbsp;с пометкой&nbsp;<strong>&laquo;Актуализация данных&raquo;</strong>.<br/>6.4.
                Срок обработки данных не ограничен. Пользователь вправе отозвать согласие, направив запрос с
                пометкой&nbsp;<strong>&laquo;Отзыв согласия&raquo;</strong>.</p>
            <p><strong>7. Трансграничная передача данных</strong></p>
            <p>7.1. Передача данных за рубеж возможна только при условии их надлежащей защиты в стране-получателе.<br/>7.2.
                Передача в страны без адекватной защиты данных допускается только с письменного согласия Пользователя.
            </p>
            <p><strong>8. Заключительные положения</strong></p>
            <p>8.1. По вопросам обработки данных Пользователь может обратиться к Оператору по
                адресу&nbsp;info@avtometod.ru.<br/>8.2. Политика может обновляться. Актуальная версия доступна на
                сайте:&nbsp;<a href="avtometod.ru/policy">https://avtometod.ru/policy</a>.</p>
            <p><strong>ООО "УЦ "АвтоМетод"</strong><br/>&nbsp;Москва, ул. Братиславская, д.
                8<br/>&nbsp;info@avtometod.ru<br/><strong>&nbsp;Режим работы:</strong>&nbsp;ВТ-СБ: 11:00&ndash;20:00,
                ПН-ВС: выходной<br/>&copy; 2024&ndash;2025</p>
            <p>&nbsp;</p>
            <FooterComponent/>
        </div>
    );
};

export default PolicyPage;